import Immutable                        from 'immutable';
import { QUOTE_SUCCESS, QUOTE_FAILURE } from 'pu-redux/actions/QuoteActions';
import DefaultQuote                     from '../data/DefaultQuote';

const quote = (state = Immutable.fromJS(DefaultQuote), action) => {
  switch (action.type) {
    case QUOTE_SUCCESS:
      return Immutable.fromJS(action.quote);

    case QUOTE_FAILURE:
      return Immutable.fromJS({});

    default:
      return state;
  }
};

export default quote;
